;(function () {
	const MOBILE_BREAKPOINT = 750
	const swiperInstances = new Map()

	const toBoolean = (value) => value === 'true'

	const destroySlider = (sectionId, sliderRoot) => {
		const swiperEl = sliderRoot.querySelector('.docenti-slider__track')
		const swiper = swiperInstances.get(sectionId)
		if (swiper && typeof swiper.destroy === 'function') {
			swiper.destroy(true, true)
			swiperInstances.delete(sectionId)
		}
		if (swiperEl) {
			swiperEl.classList.remove('swiper-initialized')
		}
	}

	const initSlider = (sliderRoot) => {
		const sectionId = sliderRoot.dataset.id
		if (!sectionId || swiperInstances.has(sectionId)) return

		const swiperEl = sliderRoot.querySelector('.docenti-slider__track')
		if (!swiperEl || typeof Swiper === 'undefined') return

		const perRow = +sliderRoot.dataset.perRow || 4
		const speed = +sliderRoot.dataset.speed * 1000
		const delay = +sliderRoot.dataset.delay * 1000
		const autoplay = toBoolean(sliderRoot.dataset.autoplay)
		const mobileAutoplay = toBoolean(sliderRoot.dataset.mobileAutoplay)
		const stopAutoplay = toBoolean(sliderRoot.dataset.stopAutoplay)
		const showArrows = toBoolean(sliderRoot.dataset.showArrows)
		const docentiCount = +sliderRoot.dataset.docentiCount

		let autoplayParam = {}
		if (
			document.body.offsetWidth > MOBILE_BREAKPOINT &&
			autoplay &&
			docentiCount > perRow
		) {
			autoplayParam = {
				autoplay: {
					delay,
					pauseOnMouseEnter: stopAutoplay,
					disableOnInteraction: false,
				},
			}
		} else if (
			document.body.offsetWidth <= MOBILE_BREAKPOINT &&
			mobileAutoplay
		) {
			autoplayParam = {
				autoplay: {
					delay,
					pauseOnMouseEnter: stopAutoplay,
					disableOnInteraction: false,
				},
			}
		}

		let arrowsParam = {}
		if (showArrows) {
			arrowsParam = {
				navigation: {
					nextEl: `#${sectionId} .docenti-slider__nav .swiper-button-next`,
					prevEl: `#${sectionId} .docenti-slider__nav .swiper-button-prev`,
				},
			}
		}

		const paginationEl = sliderRoot.querySelector('.docenti-slider__pagination')

		const swiperParams = {
			speed,
			keyboard: true,
			slidesPerView: 1.2,
			spaceBetween: 0,
			breakpoints: {
				576: {
					slidesPerView: 2.2,
				},
				750: {
					slidesPerView: 2.2,
				},
				990: {
					slidesPerView: perRow + 0.5,
				},
			},
			...arrowsParam,
			...autoplayParam,
		}

		if (paginationEl) {
			swiperParams.pagination = {
				el: paginationEl,
				clickable: true,
			}
		}

		const swiper = new Swiper(swiperEl, swiperParams)

		swiperInstances.set(sectionId, swiper)
	}

	const syncSlider = (sliderRoot) => {
		const sectionId = sliderRoot.dataset.id
		if (!sectionId) return

		destroySlider(sectionId, sliderRoot)
		initSlider(sliderRoot)
	}

	const initDocentiSliders = () => {
		document
			.querySelectorAll('.docenti-slider__swiper-root')
			.forEach((sliderRoot) => {
				syncSlider(sliderRoot)
			})
	}

	initDocentiSliders()

	document.addEventListener('shopify:section:load', initDocentiSliders)
	document.addEventListener('shopify:section:unload', (event) => {
		const sliderRoot = event.target.querySelector('.docenti-slider__swiper-root')
		if (!sliderRoot) return
		destroySlider(sliderRoot.dataset.id, sliderRoot)
	})

	let resizeTimer
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer)
		resizeTimer = setTimeout(initDocentiSliders, 150)
	})
})()
